<!--
  Simple Symptom Checker Popup
  - Title uses <p> (semibold) instead of <h4>
  - Tight typography, aligned text, controlled spacing
  - Flat CTA buttons that match the login page
-->
<div class="scp" role="dialog" aria-modal="true" [attr.aria-label]="title || 'Symptom checker'">
  <div class="scp__body">
    @if (title) {
      <h1 class="scp__title">{{ title }}</h1>
    }
    <p class="scp__message">{{ message }}</p>
  </div>

  <div class="scp__actions">
    @if (mode === 'yes_no') {
      <button
        type="button"
        class="scp__btn scp__btn--yes"
        (click)="dismissYes()"
        [attr.aria-label]="yesText">
        {{ yesText }}
      </button>
      <button
        type="button"
        class="scp__btn scp__btn--no"
        (click)="dismissNo()"
        [attr.aria-label]="noText">
        {{ noText }}
      </button>
    } @else {
      <button
        type="button"
        class="scp__btn scp__btn--ok"
        (click)="dismissOk()"
        [attr.aria-label]="okText">
        {{ okText }}
      </button>
    }
  </div>
</div>
